import { ArticleCategory, ArticleType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { SINGLE_UNIT_ARTICLE_TYPES } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useArticleTypes';
import { FormItemSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/schemas/FormItemSchema';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';

export const CartItemDialogFormSchema = (t: GetTextIdTranslationType) =>
  z.object({
    item: FormItemSchema(t)
      // FIXME
      // rules involving multiple form fields must be stated here, otherwise there's a type error in FormItemScheme
      // in Zod 4 (https://github.com/colinhacks/zod/issues/2474) it might be possible
      .refine((data) => !(data.category === ArticleCategory.DISCOUNT && Number(data.price) > 0), {
        message: t('AMOUNT_MUST_BE_NEGATIVE'),
        path: ['price'],
      })
      .refine((data) => !(data.category !== ArticleCategory.DISCOUNT && Number(data.price) < 0), {
        message: t('AMOUNT_MUST_BE_POSITIVE'),
        path: ['price'],
      })
      .refine((data) => !(SINGLE_UNIT_ARTICLE_TYPES.includes(data.type) && Number(data.units) > 1), {
        message: t('MORE_THAN_ONE_UNIT_ERROR'),
        path: ['units'],
      })
      .refine((data) => !(data.type === ArticleType.FLIGHT && data.isRoundTrip && !data.returnDate), {
        message: t('REQUIRED_FIELD'),
        path: ['returnDate'],
      })
      .refine((data) => !(data.type === ArticleType.AUTOMOBILE && !(data.isNewVehicle || data.registrationDate)), {
        message: t('REQUIRED_FIELD'),
        path: ['registrationDate'],
      }),
  });

export type CartItemDialogFormFields = z.infer<ReturnType<typeof CartItemDialogFormSchema>>;
